import { PaymentLogFilters } from "../types/paymentStats";

export const paymentStatsEndpoints = {
    getPaymentLogs: {
        query: (filters: PaymentLogFilters) => ({
            url: "/admin/payment-stats",
            params: filters,
        }),
        providesTags: () => [{ type: "PaymentLogs" as const, id: "LIST" }],
    },

    getPaymentLogDetail: {
        query: (id: number) => `/admin/payment-stats/${id}`,
        providesTags: (_result: any, _error: any, id: number) => [
            { type: "PaymentLogs" as const, id },
        ],
    },

    getPaymentStatistics: {
        query: (params: { date_from?: string; date_to?: string }) => ({
            url: "/admin/payment-stats/statistics",
            params,
        }),
        providesTags: () => [{ type: "PaymentStats" as const, id: "LIST" }],
    },

    getUserPaymentStats: {
        query: (params: {
            userId: number;
            date_from?: string;
            date_to?: string;
        }) => ({
            url: `/admin/payment-stats/users/${params.userId}`,
            params: { date_from: params.date_from, date_to: params.date_to },
        }),
        providesTags: (
            _result: any,
            _error: any,
            params: { userId: number }
        ) => [{ type: "PaymentLogs" as const, id: `user-${params.userId}` }],
    },

    exportPaymentLogs: {
        query: (filters: PaymentLogFilters) => ({
            url: "/admin/payment-stats/export",
            params: filters,
        }),
    },
};

export const paymentStatsTags = ["PaymentLogs", "PaymentStats"] as const;
